/**
 * True when the current URL is the standalone /qr-login store-fallback page (SVS-3635).
 *
 * That page renders for anonymous visitors before the app boots, so everything keyed off this
 * predicate must stay out of its path: trackers, the local store, and — critically — the
 * module-scope userinfo fetch in store/scope.ts, whose 401 handler redirects to the auth page.
 * Slash-tolerant so a mangled link (/qr-login/) cannot fall through to the full boot.
 */
export function isStandaloneQrLoginPage(): boolean {
  return window.location.pathname.replace(/\/+$/, "") === "/qr-login";
}
